module.exports = __webpack_public_path__ + "source/img/thumb-up-line.ccd81e08.svg";